import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { CustomFilterGroupDTO } from '@sb-tools/typescript/models/dto/custom-filter-group.dto';

@Injectable({
    providedIn: 'root',
})
export class CustomFiltersService {
    constructor(private httpClient: HttpClient) {}

    getAll(): Observable<CustomFilterGroupDTO[]> {
        return this.httpClient.get<CustomFilterGroupDTO[]>(environment.apiInboxUrl + 'customFilterGroups');
    }
}
